<template>
  <div></div>
</template>

<script>
// import InputSettings from "./InputSettings";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    // InputSettings,
  },
  data: function () {
    return {
      submitted: false,
      apiObjec: [],
      dir_array: [],
      errors: {},
      requiredErro: false,
      configData: [],
    };
  },

  methods: {
    ...mapActions("integration", [
      "createIntegration",
      "reAuthIntegration",
      "createConfigData",
      "setEmail"
    ]),
  },
  // watch: {
  //   getModalState(state) {
  //     console.log('watch', state);
  //     state && this.$bvModal.hide("addIntegration");
  //   },
  // },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("integration", [
      "getLoading",
      "getModalState",
      "getResponseErrors",
      "getReAuth",
      "getIntegId",
    ]),
  },
  mounted() {
    console.log(
      "mounted",
      this.$route.params.accessToken,
      this.$route.params.refreshToken
    );
    this.createConfigData([
      {
        key_id: 4,
        value: this.$route.params.refreshToken,
        key_code: "refresh_token",
      },
    ]);
    this.createIntegration({
      directory_type: this.getModalInfo.code,
      obj: { token: this.$route.params.accessToken },
    });
    this.setEmail(this.$route.params.encryptedEmail);
  },

  beforeMount() {
    // const { dir_keys } = this.getModalInfo;
    console.log("getmodalinfo", this.getModalInfo);
    // this.dir_array = dir_keys.map((item) => {
    //   return {
    //     key_code: item.key_code,
    //     value: null,
    //     name: item.key_name,
    //     id: item.id,
    //   };
    // });
  },
};
</script>